export default __webpack_public_path__ + "img/BestChoice_Logo_4c_pos_grau.e4b3406a.svg";